export default __webpack_public_path__ + "static/media/transfusion_globulos_rojos.35690d2a.pdf";